import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import { deleteGroups, getDepartments, getUserRightss, getUserRoles, getUsers, getusertype, registerUser, } from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import Select from "react-select";
import { getSecureItem } from "../../services/SecureStorage";
export default function User() {
  const UID = getSecureItem("userId");
  const [addUserModal, setAddUserModal] = useState(false);
  const [editUserModal, setEditUserModal] = useState(false);
  const [isloading, setisloading] = useState(false)
  const [deletUserId, setDeleteUserId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [department, setDepartment] = useState();
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataFilter, setDataFilter] = useState([]);
  const [userROle, setUserROle] = useState([]);
  const [userRight, setUserRight] = useState([])
  const [userData, setUserData] = useState();
  const [error, setError] = React.useState("");
  const [mobileError, setMobileError] = useState("");
  const [filterText, setFilterText] = React.useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isReste,setIsRest]=useState(false)
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
  const [UserTypeData, setUserTypeData] = useState([])
  const openEditUserModal = (data) => {

    // departement ID
    const DepartmentName = department?.find((item) => {
      if (item.Id == data?.DepartmentId) {
        return item?.Name;
      }
    });
    // const clickedDepartment = department?.filter((data,index) => data?.Id === clickedDepartmentId )
    setEditUserModal(!editUserModal);

    setSaveData({
      ...data,
      UserId:UID,
      Department: DepartmentName?.Name,
    });
  };

  const [saveData, setSaveData] = useState({
    UserId:UID,
    id: "",
    UserName: "",
    Password: "",
    ProfitCenterId: "",
    DepartmentId: [],
    Roles: "",
    Employer: 1,
    UserTypeId: '',
    UserMobile: 0 // Changed from "Mobile" to "UserMobile"
  })

  const departementOption = department?.map((el) => ({
    value: el.Id,
    label: el.Name,
  }));


  const handleChange = (e) => {
    const { name, value } = e.target;

    // Handle mobile validation separately
    if (name === "UserMobile") {
      // Validate mobile number (10 digits)
      if (value.length > 10) {
        setMobileError("Mobile number must be 10 digits");
        return;
      } else {
        setMobileError("");
      }
    }

    // Handle password validation
    if (name === "Password") {
      if (value.length > 15) {
        return;
      }
      if (value.length >= 6 && value.length <= 15) {
        setError("");
      } else {
        setError("Password must be between 6 and 15 characters.");
      }
    }

    // Update state
    setSaveData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleMultiSelectChange = (selectedOptions, action) => {
    if (addUserModal || editUserModal) {
      // For multi-select, selectedOptions is an array of selected items
      // We need to extract just the values if that's what you want to store
      const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];

      setSaveData(prevState => ({
        ...prevState,
        DepartmentId: selectedValues, // or selectedOptions if you want the full objects
      }));
    }
  };

  // Make sure your saveData state has DepartmentId initialized, probably as an array:




  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   // For add user modal
  //   if (addUserModal) {
  //     setSaveData((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));
  //   }
  //   // For edit user modal
  //   if (editUserModal) {
  //     setSaveData((prevState) => ({
  //       ...prevState,
  //       [name]: value,
  //     }));

  //   }
  // };




  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true)
  //   try {
  //     const response = await registerUser(saveData); // Await the API call

  //     if (response?.data) {
  //       toast.success(response.data.message || "User added successfully."); // Success toast
  //       fetchUsers(); // Refresh user list
  //       openAddUserModal(); // Close the modal
  //     } else {
  //       console.error("Unexpected response:", response);
  //       toast.error("An unexpected error occurred."); // Error toast
  //     }
  //   } catch (error) {
  //     console.error("Error adding user:", error);
  //     toast.error("UserName Already Exist"); // Error toast for duplicate user
  //   } finally {
  //     setLoading(false); // Reset the loading state
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission
  setLoading(true);

  // Validate password length
  if (saveData.Password.length < 6 || saveData.Password.length > 15) {
    toast.error("Password must be between 6 and 15 characters.");
    setLoading(false);
    return; // Stop further execution if validation fails
  }

  try {

    const response = await registerUser(saveData); // Await the API call

    if (response?.data) {
      toast.success(response.data.message || "User added successfully."); // Success toast
      fetchUsers(); // Refresh user list
      openAddUserModal(); // Close the modal
    } else {
      console.error("Unexpected response:", response);
      toast.error("An unexpected error occurred."); // Error toast
    }
  } catch (error) {
    console.error("Error adding user:", error);
    if (error.response?.data?.message) {
      toast.error(error.response.data.message); // Show API error message (e.g., duplicate user)
    } else {
      toast.error("Failed to add user. Please try again."); // Generic error
    }
  } finally {
    setLoading(false); // Reset the loading state
  }
};



  // const handleEdit = async (e) => {
  //   e.preventDefault()
  //   setLoading(true);
  //   const { UserName, Password, DepartmentId, Roles } = saveData;
  //   // Set loading state and proceed with the API cal
  //   try {
  //     const response = await registerUser(saveData);
  //     if (response) {
  //       toast.success("User Updated successfully"); // Success toast
  //       fetchUsers(); // Refresh user list
  //       openEditUserModal(); // Close the modal
  //     } else {
  //       toast.error("Error updating user. Please try again."); // Error toast
  //     }
  //   } catch (error) {
  //     console.error("Error updating user:", error.response.data);
  //     toast.error(error.response.data.message||"An unexpected error occurred. Try again."); // Error toast for unexpected error
  //   } finally {
  //     setLoading(false);

  //   }
  // };

  const handleEdit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setLoading(true);

    // Validate password length
    if (saveData.Password.length < 6 || saveData.Password.length > 15) {
      // toast.error("Password must be between 6 and 15 characters.");
      setLoading(false);
      return; // Stop further execution if validation fails
    }

    try {
      const response = await registerUser(saveData); // Await the API call
      if (response) {
        toast.success("User Updated successfully"); // Success toast
        fetchUsers(); // Refresh user list
        openEditUserModal(); // Close the modal
      } else {
        toast.error("Error updating user. Please try again."); // Error toast
      }
    } catch (error) {
      console.error("Error updating user:", error.response?.data || error);
      toast.error(
        error.response?.data?.message || "An unexpected error occurred. Try again."
      ); // Error toast for unexpected error
    } finally {
      setLoading(false); // Reset the loading state
    }
  };



  const handleDelete = async (userId) => {
    const removeData = { Id: userId, TableName: "UserSettings" };
    try {
      const res = await deleteGroups(removeData, UID); // Await the Promise
      

      if (res && res.data) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("User deleted successfully");
          fetchUsers(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting User");
      }
    } catch (error) {
      // Check for specific error status and handle gracefullyedit
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting User.";
        toast.error("User already using, cannot delete.");
      } else {
        console.error("Error removing User:", error);
        toast.error("Error deleting User. Please try again.");
      }
    }
  };



  const handleClearsevadata = () => {
    setSaveData({
      id: "",
      UserName: "",
      Password: "",
      ProfitCenterId: "",
      UserMobile: "",  // Changed from "Mobile" to "UserMobile"
      DepartmentId: "",
      Roles: "",
      Employer: 1,
      UserTypeId: ''
    });
    setMobileError("");  // Clear mobile error
    setError("");  // Clear password error
  }
  
  const clearDataForEdit = () => {
    setSaveData(prevState => ({
      ...prevState,
      UserName: "",
      Password: "",
      ProfitCenterId: "",
      DepartmentId: "",
      UserMobile: "",  // Changed from "Mobile" to "UserMobile"
      Roles: "",
      Employer: 1,
      UserTypeId: ''
    }));
    setMobileError("");  // Clear mobile error
    setError("");  // Clear password error
  };

  const openAddUserModal = () => {
    setAddUserModal(!addUserModal);
    handleClearsevadata()
  };


  const selectedDepartMent = department?.filter((data, index) => data.Id === userData?.DepartmentId)



  const fetchUsers = async () => {
    try {
      const data = await getUsers(UID);
      setUserData(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching users", error);
    }
    setLoading(false);
  };

  const fetchusertype = async () => {
    const Details = {
      UserId: UID
    }
    try {
      const data = await getusertype(Details);
      setUserTypeData(data.data.data);
    } catch (error) {
      console.error("Error fetching users", error);
    }
    setLoading(false);
  };


  const fetchUserRole = async () => {
    try {
      const response = await getUserRoles(UID);

      setUserROle(response.data.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };
  const fetchUserRights = async () => {
    try {
      const response = await getUserRightss(UID);

      setUserRight(response.data.data);
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };




  const openModal = (userId) => {
    setDeleteUserId(userId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteUserId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deletUserId) {
      handleDelete(deletUserId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };


  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Name",
      selector: (row) => row.UserName,
      sortable: true,
    },

    {
      name: "Department",
      selector: (row) => {
        if (!row.DepartmentId) return "N/A"; // Handle missing DepartmentId

        const departmentIds = row.DepartmentId.split(","); // Split the comma-separated string
        const matchingDepartments = departmentIds
          .map((id) => department?.find((el) => el.Id === id)) // Find matching departments
          .filter((dept) => dept) // Remove null/undefined matches
          .map((dept) => dept.Name); // Extract department names

        return matchingDepartments.length > 0
          ? matchingDepartments.join(", ") // Join matching department names
          : "N/A"; // Default if no matches found
      },
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditUserModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>


        </div>
      ),
    },
  ];



  const filteredItems = dataFilter.filter((item) => {
    const dept = department?.find((el) => el.Id === item.DepartmentId);
    return (
      item.UserName?.toLowerCase().includes(filterText.toLowerCase()) ||
      (dept && dept.Name?.toLowerCase().includes(filterText.toLowerCase()))
    );
  });

  const subHeaderComponentMemo = useMemo(() => {
  }, [filterText, resetPaginationToggle]);


  useEffect(() => {

    if (userData && userData.length > 0) {
      const updatedData = userData.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        UserName: item.UserName || "",
        Password: item.Password || "",
        Department: item.Department || "",
        Employer: item.Employer || "",
        Roles: item.Roles || "",
        UserMobile: item.UserMobile || "",
        DepartmentId: item.DepartmentId || '',
        UserTypeId: item.UserTypeId || "",

      }));
      setDataFilter(updatedData);
    } else {
      setDataFilter([])


    }
  }, [userData]);


  useEffect(() => {
    setLoading(true);
    fetchUsers();
    fetchUserRole();
    fetchUserRights()
    fetchusertype();
  }, []);


  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchProfitCenters();
  }, []);



  useEffect(() => {
    document.body.classList[addUserModal ? "add" : "remove"]("overflow-hidden");
  }, [addUserModal]);


  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this User?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="User" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Name/Department"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddUserModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={userData} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>
      {/* =====================================Add=================================================== */}

      {addUserModal && (
        <>

          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add New User
                <span className="absolute top-0 right-0">
                  <button onClick={openAddUserModal} className="btn flex items-center justify-center">
                    ✖
                  </button>
                </span>
              </h5>
              <form onSubmit={handleSubmit} className="my-10 md:px-10 px-[7px] "
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>User Type <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="UserTypeId"
                        value={saveData.UserTypeId || ''}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select User Type
                        </option>
                        {UserTypeData?.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group md:col-span-12 col-span-12 flex-col gap-2">
                      <label htmlFor="userName">User Name  <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="userName"
                        name="UserName"
                        placeholder="User Name"
                        value={saveData.UserName}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "UserName", value: e.target.value.trim() } });
                        }}

                      />
                    </div>

                    <div className="form-group md:col-span-12 col-span-12 flex-col gap-2">
                      <label htmlFor="UserMobile">
                        Mobile <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="UserMobile"
                        name="UserMobile"  // Changed from "Mobile" to "UserMobile"
                        placeholder="Enter Mobile No"
                        value={saveData.UserMobile || ''}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                        required
                        maxLength={10}
                      />
                      {mobileError && <p className="text-red-500">{mobileError}</p>}
                    </div>

                    <div className="form-group md:col-span-12 col-span-12 flex-col gap-2">
                      <label htmlFor="password">Password <span style={{ color: 'red' }}>*</span></label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"} // Toggle between text and password
                          id="password"
                          name="Password"
                          placeholder="Password"
                          value={saveData.Password}
                          onChange={handleChange}
                          required
                          onBlur={(e) => {
                            handleChange({ target: { name: "Password", value: e.target.value.trim() } });
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                          className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                        >
                          {showPassword ? "Hide" : "Show"}
                        </button>
                      </div>
                      {error && <span style={{ color: 'red' }}>{error}</span>}
                    </div>
                    {
                      UserTypeData.some((el) => el.Id && el.Name === 'DepartmentHead' && el.Id === saveData.UserTypeId) ? (

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Department  <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Select
                            name="DepartmentId"
                            value={departementOption.filter(option => saveData.DepartmentId.includes(option.value))} // Make sure to set this from your state
                            onChange={handleMultiSelectChange}
                            options={departementOption}
                            isMulti
                            placeholder="Select Departments"
                          />


                        </div>
                      ) : (
                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Department  <span style={{ color: 'red' }}>*</span>
                          </label>
                          <select
                            name="DepartmentId"
                            value={saveData.DepartmentId}
                            onChange={handleChange}
                            required
                          >
                            <option key="" value="">
                              Select Department
                            </option>
                            {department.map((data) => (
                              <option key={data.Id} value={data.Id}>
                                {data.Name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )
                    }

                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        User Role <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="Roles"
                        value={saveData.Roles}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select User Role
                        </option>
                        {userROle
                          .filter((role) =>
                            userRight.some((right) => right.UserroleId === role.Id)
                          )
                          .map((role) => (
                            <option key={role.Id} value={role.Id}>
                              {role.Name}
                            </option>
                          ))}
                      </select>
                    </div>



                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={handleClearsevadata}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button type="submit" disabled={isloading} className="btn btn-primary">
                    Add
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div
            // onClick={openAddUserModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* =====================================Edit=================================================== */}

      {editUserModal && (
        <>
          <form onSubmit={handleEdit}>
            <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
              <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
                <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                  Edit User
                  <span className="absolute top-0 right-0">
                    <button onClick={openEditUserModal} className="btn flex items-center justify-center">
                      ✖
                    </button>
                  </span>
                </h5>
                <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                  <div className="grid grid-cols-12 gap-20">

                    <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>User Type <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="UserTypeId"
                        value={saveData.UserTypeId || ''}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select User Type
                        </option>
                        {UserTypeData?.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group md:col-span-12 col-span-12 flex-col gap-2">
                      <label htmlFor="userName">User Name <span style={{ color: 'red' }}>*</span></label>
                      <input
                        type="text"
                        id="userName"
                        name="UserName"
                        placeholder="User Name"
                        value={saveData.UserName}
                        onChange={handleChange}
                        required
                        onBlur={(e) => {
                          handleChange({ target: { name: "UserName", value: e.target.value.trim() } });
                        }}
                      />
                    </div>

                    <div className="form-group md:col-span-12 col-span-12 flex-col gap-2">
                      <label htmlFor="UserMobile">
                        Mobile <span style={{ color: 'red' }}>*</span>
                      </label>
                      <input
                        type="number"
                        id="UserMobile"
                        name="UserMobile"  // Changed from "Mobile" to "UserMobile"
                        placeholder="Enter Mobile No"
                        value={saveData.UserMobile || ''}
                        onChange={handleChange}
                        onWheel={(e) => e.target.blur()}
                        required
                        maxLength={10}
                      />
                      {mobileError && <p className="text-red-500">{mobileError}</p>}
                    </div>
                    
                    <div className="form-group col-span-12 flex-col gap-2">
                      <label htmlFor="password">Password <span style={{ color: 'red' }}>*</span></label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"} // Toggle between text and password
                          id="Password"
                          name="Password"
                          placeholder="Password"
                          value={saveData.Password}
                          onChange={handleChange}
                          required
                          onBlur={(e) => {
                            handleChange({ target: { name: "Password", value: e.target.value.trim() } });
                          }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)} // Toggle visibility
                          className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                        >
                          {showPassword ? "Hide" : "Show"} {/* Toggle icon */}
                        </button>
                      </div>
                      {error && <span style={{ color: 'red' }}>{error}</span>}
                    </div>
                    {
                      UserTypeData.some((el) => el.Id && el.Name === 'DepartmentHead' && el.Id === saveData.UserTypeId) ? (

                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Department  <span style={{ color: 'red' }}>*</span>
                          </label>
                          <Select
                            name="DepartmentId"
                            value={departementOption.filter(option => saveData.DepartmentId.includes(option.value))} // Make sure to set this from your state
                            onChange={handleMultiSelectChange}
                            options={departementOption}
                            isMulti
                            placeholder="Select Departments"
                          />


                        </div>
                      ) : (
                        <div className="form-group flex col-span-12 flex-col">
                          <label>
                            Department  <span style={{ color: 'red' }}>*</span>
                          </label>
                          <select
                            name="DepartmentId"
                            value={saveData.DepartmentId}
                            onChange={handleChange}
                            required
                          >
                            <option key="" value="">
                              Select Department
                            </option>
                            {department.map((data) => (
                              <option key={data.Id} value={data.Id}>
                                {data.Name}
                              </option>
                            ))}
                          </select>
                        </div>
                      )
                    }


                    {/* <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>UserRole <span style={{ color: 'red' }}>*</span></label>
                      <select
                        name="Roles"
                        value={saveData.Roles}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select UserRole
                        </option>
                        {userROle.map((center) => (
                          <option key={center.Id} value={center.Id}>
                            {center.Name}
                          </option>
                        ))}
                      </select>
                    </div> */}  <div className="form-group flex col-span-12 flex-col gap-2">
                      <label>
                        User Role <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="Roles"
                        value={saveData.Roles}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select User Role
                        </option>
                        {userROle
                          .filter((role) =>
                            userRight.some((right) => right.UserroleId === role.Id)
                          )
                          .map((role) => (
                            <option key={role.Id} value={role.Id}>
                              {role.Name}
                            </option>
                          ))}
                      </select>
                    </div>


                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button type="button"
                    onClick={clearDataForEdit}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button type="submit" disabled={isloading} className="btn btn-primary">
                    Edit
                  </button>
                </div>
              </div>
            </div>
          </form>

          <div
            // onClick={openEditUserModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
